<!--  -->
<template>
  <div v-loading="loading" class="editAnnouncement">
    <header class="header">
      <span>编辑/新建公告</span>
      <!-- <el-button type="primary" @click="saveSubmit">保存</el-button> -->
      <el-button @click="$router.go(-1)" class="fr">返回</el-button>
    </header>

    <el-form :model="announcement" ref="announcement" label-width="150px">
      <el-form-item label="公告名称" prop="title" :rules="[{ required: true, message: '公告名称不能为空'}]">
        <el-input
          type="title"
          v-model="announcement.title"
          placeholder="请输入公告名称"
          style="width:480px;"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="可见授课班级"
        prop="courseIds"
        :rules="[{ required: true, message: '可见授课班级不能为空'}]"
      >
        <el-checkbox-group v-model="announcement.courseIds">
          <el-checkbox v-for="item in teachingClass" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="公告内容" prop="detail" :rules="[{ required: true, message: '公告内容不能为空'}]">
        <rich-editor :value="announcement.detail" ref="answer"></rich-editor>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('announcement')">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import richEditor from "@/components/common/RichEditor.vue";

export default {
  components: {
    richEditor
  },
  data() {
    return {
      loading: false,
      teachingClass: [],
      announcement: {
        announceId: 0,
        courseIds: [],
        detail: "",
        schoolId: this.$route.query.schoolId,
        teacherId: this.$route.query.teacherId,
        title: ""
      },
      param: {
        schoolId: this.$route.query.schoolId,
        teacherId: this.$route.query.teacherId
      }
    };
  },
  methods: {
    // 获取可见授课班级
    getCourseSummaryList() {
      this.loading = true;
      this.$api.allianceSchool.getCourseSummaryList(this.param).then(res => {
        this.loading = false;
        if (res.errCode == 0) {
          this.teachingClass = res.data;
        } else {
          this.$message.error(res.errMsg);
        }
      }).catch(res=>{
        this.loading = false;
      });;
    },
    // 保存
    submitForm(formName) {
      this.announcement.detail = this.$refs.answer.getContent(); // 拿到富文本的内容
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          this.$api.allianceSchool
            .updateAnnounce(this.announcement)
            .then(res => {
              this.loading = false;
              if (res.errCode == 0) {
                this.$router.go(-1)
              } else {
                this.$message.error(res.errMsg);
              }
            }).catch(res=>{
        this.loading = false;
      });;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  },
  created() {
    this.getCourseSummaryList();
  }
};
</script>
<style lang='less' scoped>
.editAnnouncement{
  background: #fff;
  padding: 10px;
  box-sizing: border-box;
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      font-size:16px;
      font-family:PingFang-SC;
      color:#424346;
    }
  }
}
</style>